export default __webpack_public_path__ + "static/media/Nitesh.08f84b58.jpg";